//constants.js
export const Constants = {
  AudioFileSizeLimit: 20 * 1024 * 1024,       //20 MB
  DocumentFileSizeLimit: 50 * 1024 * 1024,    //50 MB
  ImageFileSizeLimit: 10 * 1024 * 1024,       //10 MB
  ImportFileSizeLimit: 1024 * 1024 * 1024,    //1 GB
  SpreadsheetFileSizeLimit: 10 * 1024 * 1024, //10 MB
  VideoFileSizeLimit: 700 * 1024 * 1024,      //700 MB
  ZIPFileSizeLimit: 50 * 1024 * 1024          //50 MB
};

//File type size limits mapping
export const FileTypeSizeLimits = {
  "application/msword": Constants.DocumentFileSizeLimit,
  "application/pdf": Constants.DocumentFileSizeLimit,
  "application/vnd.ms-excel": Constants.SpreadsheetFileSizeLimit,
  "application/vnd.ms-powerpoint": Constants.DocumentFileSizeLimit,
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": Constants.DocumentFileSizeLimit,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": Constants.SpreadsheetFileSizeLimit,
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": Constants.DocumentFileSizeLimit,
  "application/zip": Constants.ZIPFileSizeLimit,
  "audio/mp4": Constants.AudioFileSizeLimit,
  "audio/mpeg": Constants.AudioFileSizeLimit,
  "image/bmp": Constants.ImageFileSizeLimit,
  "image/gif": Constants.ImageFileSizeLimit,
  "image/jpeg": Constants.ImageFileSizeLimit,
  "image/png": Constants.ImageFileSizeLimit,
  "image/svg+xml": Constants.ImageFileSizeLimit,
  "image/tiff":Constants.ImageFileSizeLimit,
  "image/webp": Constants.ImageFileSizeLimit,
  "text/csv": Constants.DocumentFileSizeLimit,
  "text/plain": Constants.DocumentFileSizeLimit,
  "video/mp4": Constants.VideoFileSizeLimit,
  "video/mpeg": Constants.VideoFileSizeLimit,
  "video/quicktime": Constants.VideoFileSizeLimit,
  "video/webm": Constants.VideoFileSizeLimit,
  "video/x-flv": Constants.VideoFileSizeLimit,
  "video/x-matroska": Constants.VideoFileSizeLimit,
  "video/x-msvideo": Constants.VideoFileSizeLimit,
};

//Import file type size limits mapping
export const ImportFileTypeSizeLimits = {
  "application/msexcel": Constants.ImportFileSizeLimit,
  "application/ms-excel": Constants.ImportFileSizeLimit,
  "application/vnd.ms-excel": Constants.ImportFileSizeLimit,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": Constants.ImportFileSizeLimit,
  "text/csv": Constants.ImportFileSizeLimit,
  "text/plain": Constants.ImportFileSizeLimit,
};